import React from 'react';
import { flagChipCls, flagLabel } from './cpdFlags';

// The flags on one External CPD row, as chips: amber while unconfirmed, grey
// once someone has confirmed them. Hover shows the detail.
const CpdFlagChips = ({ flags = [] }) => {
  if (!flags.length) return <span className="text-slate-400">—</span>;
  return (
    <span className="inline-flex flex-wrap gap-1">
      {flags.map((f) => (
        <span
          key={f.code}
          title={f.confirmedAt ? `${f.detail} (confirmed by ${f.confirmedBy || 'HR'})` : f.detail}
          className={`inline-flex items-center px-1.5 py-0.5 rounded border text-[11px] font-medium whitespace-nowrap ${flagChipCls(f)}`}
        >
          {flagLabel(f.code)}
        </span>
      ))}
    </span>
  );
};

export default CpdFlagChips;
